export default {
    IDENTIFICATION_TYPE: 1,
    PAYMENT_METHOD: 2,//Medio de pago
    WAY_PAY: 3,//Formas de pago
    COMPANY_INFO: 4,
    VEHICLE_TYPE: 5,
    LOCATION: 6,
    TECHNOLOGIES: 9,
    DEVICE_TYPES: 11,
    LIQUIDATIONS: 12,
    CUSTOMER_TYPE: 14,
    CONCEPTS: 16,
    SCHEDULES: 17,
    VOUCHER_SECTIONS: 18,
    USER_REGIME: 19,
    FISCAL_RESPONSIBILITY: 20,
    INCOME_TYPES: 21,
    TENANT_TYPES: 22,
    MONTHLY_SERVICE_TYPE: 24,
    LIQUIDATION_TYPES: 25,
    RUNTIME_TYPES: 29,
    INTEGRATION_TYPES:30,// Integraciones de software contable
};
